module.exports = __webpack_public_path__ + "static/media/cUSDC-logo.237021c9.png";